import { orderListRoute, orderDetailRoute } from "./order";

export const allOrderRoute = [orderListRoute(), orderDetailRoute()];
